import { v4 as uuidv4 } from 'uuid';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal';

import { ADD_MODE_PARAM, EDIT_MODE_PARAM, FIND_MODE_PARAM } from './constants';

@Component({
  standalone: false,
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>

      <ideapa-icon-button
        icon="close"
        (clicked)="activeModal.dismiss()"
        cssClasses="text-primary hover-bg-primary"
      ></ideapa-icon-button>
    </div>
    <div class="flex-grow-1">
      <iframe
        class="rounded-3"
        [src]="sanitizedUrl"
        width="100%"
        height="100%"
        frameborder="0"
        style="border:0"
        allowfullscreen
        onload="this.contentWindow.focus()"
      ></iframe>
    </div>
  `,
  styles: [
    `
      :host {
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      .modal-body {
        flex-grow: 1;
      }
    `,
  ],
})
export class ModalWrapperComponent implements OnInit, OnDestroy {
  @Input() entity!: string;

  @Input()
  mode!: string;

  @Input() id?: number;

  @Input()
  title?: string;

  @Input()
  queryParams?: string;

  sanitizedUrl!: SafeResourceUrl;

  private bc?: BroadcastChannel;

  constructor(
    private sanitizer: DomSanitizer,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    if (!this.entity || !this.mode) throw new Error('mandatory data missing');

    if (!this.title) {
      const entityDisplayName = this.entity.replaceAll('-', ' ');
      this.title = this.getTitle(entityDisplayName);
    }

    this.loadIFrame();
  }

  ngOnDestroy(): void {
    this.bc?.close();
  }

  loadIFrame() {
    const channelName = uuidv4();
    const url =
      window.location.origin +
      '/modal/' +
      this.entity +
      (this.id != null ? '/' + this.id : '') +
      `?${this.mode}=${channelName}${
        this.queryParams ? '&' + this.queryParams : ''
      }`;

    this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    this.bc = new BroadcastChannel(channelName);
    this.bc.onmessage = (ev) => {
      // console.log('received msg item added', ev.data);
      if (
        this.mode === EDIT_MODE_PARAM ||
        this.mode === ADD_MODE_PARAM ||
        this.mode === FIND_MODE_PARAM
      ) {
        this.bc?.close();
        this.activeModal.close(ev.data);
      }
    };
  }

  private getTitle(entityDisplayName: string) {
    return this.id != null
      ? this.id != 0
        ? (this.mode === EDIT_MODE_PARAM ? 'Modifica ' : 'Visualizza ') +
          entityDisplayName
        : 'Aggiungi ' + entityDisplayName
      : 'Ricerca ' + entityDisplayName;
  }
}
